/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { SidebarGlobal } from "./_SidebarGlobal";
import Paging from "./Paging";
import Auth from "../shared/Auth";
import FormInput from "./FormInput";
import Globals from "../shared/Globals";

class PaymentTransactions extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {
                page: props.params.page ?? 1,
                qfilters: {},
                search: null
            },
            filters: {},
            loaded: false,
            loading: false,
            list: [],
            req: {}
        };
        this.load = this.load.bind(this);
        this.onFilter = this.onFilter.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.page !== this.props.params.page) {
            this.setState({ query: { ...this.state.query, page: this.props.params.page || 1 } });
        }
        if (prevState.query !== this.state.query) {
            if (this.state.query)
                this.load();
        }
    }

    dateFilter(filters, varNames, val) {
        var n = 0;
        if (val) {
            varNames.forEach(i => {
                filters[i] = val[n];
                n++;
            });
        }
        else {
            varNames.forEach(i => {
                delete filters[i];
            });
        }
    }

    onFilter(col) {
        var filters = { ...this.state.filters };

        if (col.filter.filter === 'invoicedate') this.dateFilter(filters, ['InvoideStartDate', 'InvoiceEndDate'], col.filter.value);
        else {
            if (col.filter.value)
                filters[col.filter.filter] = col.filter.value;
            else
                delete filters[col.filter.filter];
        }
        var query = { ...this.state.query, qfilters: filters };
        this.setState({ filters: filters, query: query });
    }

    load(query) {
        if (!query)
            query = this.state.query;
        this.setState({ loading: true });
        qreq.post('/api/payment-transaction/list', query, j => {
            if (j.list) {
                this.setState({ list: j.list, pageCount: j.pageCount, totalCount: j.totalCount });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    search = (v) => {
        let query = { ...this.state.query, search: v };
        this.setState({ query: query });
    }



    render() {
        const header = (<h1><L>Payment Transactions</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        const columns = [
            { name: 'name', title: 'Name' },
            { name: 'createdDate', title: 'Created Date', valueFunc: row => Globals.toMDYHMLocalDateStringOrDiff(row.createdDate, true), className: 'd-none d-md-table-cell' },
            { name: 'transactionID', title: 'Transaction ID' },
            { name: 'chargeAmount', title: 'Amount', valueFunc: row => Globals.formatCurrency(row.chargeAmount) },
            {
                name: 'status', title: 'Status', valueFunc: i => {
                    if (i.confirmed)
                        return 'Paid';
                    return 'Pending';
                }
            }
        ];


        return <div className="container-fluid">
            {header}
            {false && <div>
                <FormInput
                    model={this.state.query}
                    name="search"
                    type="text"
                    onChange={this.search}
                    label="Search..."
                    labelAsPlaceholder
                />
            </div>}
            <DataTable columns={columns} data={this.state.list} loading={this.state.loading} totalCount={this.state.totalCount} />
            <div className="card-body">
                <Paging baseLoc="/payment-transaction/list/page/" pageCount={this.state.pageCount} currentPage={this.state.query?.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>



        </div>;
    }
}

export default withParamsAndNavigate(PaymentTransactions);